import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form, Card, Col, Container, Row } from "react-bootstrap";
import Nav from "./Navbar";
import pay from "../Images/pay.png";
import Footer from "./Footer";
import serp1 from "../Images/serp1.png";
import serp2 from "../Images/serp2.png";
import SideTab from "./Toolstab";
import {
  FaChartBar,
  FaChevronLeft,
  FaChevronRight,
  FaFileAlt,
  FaSearch,
} from "react-icons/fa";
import { Helmet } from "react-helmet";
const Serp = () => {
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Seobix SERP Simulator – Google Snippet Preview Tool",
    url: "https://seobix.com/serp-simulator",
    description:
      "Preview how your pages appear in Google SERP with Seobix’s SERP Simulator. Test titles, descriptions & URLs for better click-through and SEO performance.",
    publisher: {
      "@type": "Organization",
      name: "Seobix",
      url: "https://seobix.com",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/Images/Backlinks.png",
      },
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Seobix SERP Simulator",
          item: "https://seobix.com/serp-simulator",
        },
      ],
    },
    mainEntity: {
      "@type": "SoftwareApplication",
      name: "Seobix SERP Simulator",
      applicationCategory: "SEO Tool",
      operatingSystem: "Web",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
        category: "Free SEO Tool",
      },
    },
    inLanguage: "en",
    keywords: [
      "SERP simulator",
      "Google snippet preview",
      "SEO tool",
      "meta title simulator",
      "search engine optimization",
      "keyword research",
      "site analysis",
      "SEO performance",
    ],
    mainEntityOfPage: [
      {
        "@type": "Question",
        name: "What is a SERP simulator?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "A SERP simulator is a tool that lets you preview how your web page will appear in Google search results, including title, meta description, and URL.",
        },
      },
      {
        "@type": "Question",
        name: "How does Seobix SERP Simulator work?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Seobix SERP Simulator lets you test your page titles, descriptions, and URLs in real-time to optimize for click-through rates and SEO performance.",
        },
      },
      {
        "@type": "Question",
        name: "Is it free to use?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, Seobix SERP Simulator is completely free to use for previewing and testing your page snippets.",
        },
      },
    ],
  };

  return (
    <div>
      <Helmet>
        <title>Seobix SERP Simulator – Google Snippet Preview Tool</title>
        <meta
          name="description"
          content="Preview how your pages appear in Google SERP with Seobix’s SERP Simulator. Test titles, descriptions & URLs for better click-through and SEO performance."
        />
        <meta
          name="keywords"
          content="search engine optimization keywords, optimize seo, website analysis online, free seo site checker, search backlinks, tools seo, googlesearch console, kw research, keyword search tools free, analyze site traffic, generate keyword, google ranking, search engine optimization keyword research, keyword research"
        />
        <link rel="canonical" href="https://seobix.com/serp-simulator" />

        <meta
          property="og:title"
          content="Seobix SERP Simulator – Google Snippet Preview Tool"
        />
        <meta
          property="og:description"
          content="Preview how your pages appear in Google SERP with Seobix’s SERP Simulator. Test titles, descriptions & URLs for better click-through and SEO performance."
        />
        <meta property="og:url" content="https://seobix.com/serp-simulator" />
        <meta property="og:site_name" content="Seobix" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://seobix.com/Images/Backlinks.png"
        />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="600" />
        <meta property="og:locale" content="en_US" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Seobix SERP Simulator – Google Snippet Preview Tool"
        />
        <meta
          name="twitter:description"
          content="Preview how your pages appear in Google SERP with Seobix’s SERP Simulator. Test titles, descriptions & URLs for better click-through and SEO performance."
        />
        <meta
          name="twitter:image"
          content="https://seobix.com/Images/Backlinks.png"
        />
        <meta name="twitter:site" content="@seobix" />
        <meta name="twitter:creator" content="@seobix" />

        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
      </Helmet>
      <Nav />
      <Container fluid className="p-0 mt-5">
        <Row className="justify-content-center" style={{ margin: "0" }}>
          <Col md={10}>
            <Row className="justify-content-between">
              <Col md={8}>
                <Content />
              </Col>

              <Col md={3}>
                <div
                  className="mb-5"
                  style={{
                    position: "sticky",
                    top: "100px",
                    zIndex: 10,
                    background: "#f8f9fa",
                    padding: "1rem",
                    borderRadius: "10px",
                  }}
                >
                  <h5
                    className="text-center mb-4"
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.3rem",
                      color: "#fff",
                      backgroundColor: "#799EFF",
                      display: "inline-block",
                      padding: "6px 16px",
                      borderRadius: "0.5rem",
                    }}
                  >
                    🚀 Explore More SEO Tools
                  </h5>
                  <SideTab />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </div>
  );
};
const relatedTools = [
  {
    name: "Google Trends Insights",
    icon: <FaSearch size={24} color="#0A3981" />,
    desc: "Know what is searching live all over the globe. Know what people are searching in real time so that you can align your content to what is trending themes and trends of the time.",
    href: "/trending-now-on-google",
  },
  {
    name: "Google Analytics Overview",
    icon: <FaChartBar size={24} color="#0A3981" />,
    desc: "Understand how users browse on your site. Bounce rates, track sessions and traffic sources to decide using the data and to optimize the performance.",
    href: "/google-analytics",
  },
  {
    name: "Search Console Monitor",
    icon: <FaFileAlt size={24} color="#0A3981" />,
    desc: "Test your position in Google search engine. Measure clicks, impressions and rankings of keywords in order to discover opportunities and correct index issues.",
    href: "/search-console",
  },
];

const ToolSlider = () => {
  const sliderRef = useRef(null);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft -= 300;
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft += 300;
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={scrollLeft}
        style={{
          position: "absolute",
          left: "0",
          top: "-9%",
          transform: "translateY(-50%)",
          zIndex: 10,
          backgroundColor: "#799EFF",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <FaChevronLeft />
      </button>

      <button
        onClick={scrollRight}
        style={{
          position: "absolute",
          right: "0",
          top: "-9%",
          transform: "translateY(-50%)",
          zIndex: 10,
          backgroundColor: "#799EFF",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <FaChevronRight />
      </button>

      <div
        ref={sliderRef}
        className="mb-4"
        style={{
          display: "flex",
          overflowX: "auto",
          padding: "1rem",
          gap: "1rem",
          scrollbarWidth: "none",
          scrollBehavior: "smooth",
        }}
      >
        {relatedTools.map((tool, idx) => (
          <div
            key={idx}
            style={{
              minWidth: "250px",
              flex: "0 0 auto",
              background: "#f4f8ff",
              borderRadius: "12px",
              padding: "1rem",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              textAlign: "center",
              transition: "transform 0.3s",
            }}
          >
            <div style={{ marginBottom: "0.5rem" }}>{tool.icon}</div>
            <h6 style={{ color: "#0A3981", fontWeight: "bold" }}>
              {tool.name}
            </h6>
            <p
              style={{
                fontSize: "0.9rem",
                minHeight: "60px",
                lineHeight: "1.4",
              }}
            >
              {tool.desc
                .split(" ")
                .map((word, i) =>
                  (i + 1) % 7 === 0 ? word + "\n" : word + " "
                )
                .join("")
                .split("\n")
                .map((line, idx) => (
                  <span key={idx}>
                    {line.trim()}
                    <br />
                  </span>
                ))}
            </p>
            <a
              href={tool.href}
              style={{
                color: "#fff",
                backgroundColor: "#799EFF",
                padding: "6px 12px",
                borderRadius: "8px",
                textDecoration: "none",
                display: "inline-block",
                fontWeight: "bold",
              }}
            >
              Try Now →
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};
const Content = () => {
  return (
    <div className="mx-2">
      <h1 className=" text-center">
        SERP Simulator – See How Your Site Appears in Google Results
      </h1>

      <p>
        Make your first impression on Google a great one. With Seobix’s SERP (
        search engine research page ) Simulator, you can see exactly how your
        title tag, meta description, and URL will appear in search
        results—before you ever hit publish.Your page title and meta description
        aren’t just text—they’re your invitation to searchers. A well-organized
        snippet can boost exposure, encourage more clicks, and enhance SEO
        performance in general.
      </p>
      <Plancard />
      <div className="d-flex justify-content-center">
        <img
          className="m-3"
          src={serp2}
          alt="seobix"
          style={{ width: "50vw" }}
        />
      </div>
      <h2 className="mt-3">What Makes Seobix's SERP Simulator Unique?</h2>
      <p>
        Most of the SERP preview tools just give you a rough idea. Seobix goes
        further by replicating actual Google snippets with real-time accuracy
        for both desktop and mobile. You’ll get to know exactly about how your
        page looks and how it performs before it goes live. Whether you’re a
        marketer, blogger, or small business owner, our SERP Simulator helps you
        publish with confidence. Make every search listing click-worthy with the
        clarity and tools only Seobix can offer.
      </p>
      <div className="d-flex justify-content-center">
        <img
          className="m-4"
          src={serp1}
          alt="seobix"
          style={{ width: "50vw" }}
        />
      </div>
      <h3>Smart Integration with Structured Data Tools</h3>
      <p>
        Seobix is unique in this regard because our simulator integrates with
        the <b>best structured data tools for small businesses</b>, providing
        you with additional information about how structured content impacts
        your search engine ranking.This implies that you score higher in
        addition to writing better.
      </p>
      <h4
        className="text-center mt-4 mb-3"
        style={{
          fontWeight: "bold",
          fontSize: "1.5rem",
          color: "#0A3981",
        }}
      >
        🔧 Related Tools
      </h4>

      <ToolSlider />
      <Specialoffer />
      <h3>Boost Clicks & Visibility</h3>
      <p className="mb-4">
        By combining SERP previewing with actionable tips, Seobix helps you{" "}
        <b>increase website traffic with structured data</b> and smarter
        optimization. Small changes in your title and description can lead to
        big jumps in traffic—and we help you get it right.
      </p>
    </div>
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Improve Your Rankings —{" "}
          <span style={{ color: "#FC4100" }}>
            Try Our Service Free for 3 Months!
          </span>
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉{" "}
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
const Specialoffer = () => {
  return (
    <div
      className="start-now-btn p-2"
      style={{
        background: "#799EFF",
        borderRadius: "24px",
        color: "white",
        textAlign: "center",
        margin: "3rem auto",
        width: "90%",
        maxWidth: "1000px",
        position: "relative",
      }}
    >
      <h2 className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Let’s do this! Start unlocking powerful backlink insights.
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <a
          // href="/register"
          onClick={() => window.open("https://dashboard.seobix.com/", "_blank")}
          style={{
            backgroundColor: "#fff",
            color: "#000",
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textDecoration: "none",
            minWidth: "150px",
            textAlign: "center",
          }}
        >
          Start 3 Months Free Trial
        </a>
      </div>

      <p style={{ color: "#fff", marginTop: "20px", fontSize: "14px" }}>
        <b> Full access — No Credit card Needed.</b>
      </p>
    </div>
  );
};
export default Serp;
